import React from 'react';
import ArrowDown from '../../asset/ArrowDown'

// style -- background images
// title -- title in the images
// down arrow -- show icon for scrolling down (optional)

const Hero = ({style, title, downArrow, firstPage}) => (
  <div className="hero bg-photo bg-contain fadeInUp" id={firstPage} style={style}>
    {title !== ''
      ?
        <div className="hero__inner">
          <h1 className="shout slogan"style={{color: 'white',textAlign: 'center',}}>
            {title}
          </h1>
        </div>
      : null
    }
     {downArrow === true
       ? <div className="arrowAnimation"><ArrowDown/></div>
       : null
     }
  </div>
);

export default Hero;



// WEBPACK FOOTER //
// ./src/layout/hero/Hero.js